import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import SvgsCommons from "@/components/svgs/commons";
import SvgsSubscription from "@/components/svgs/subscription";
import { useActionWhenScrollToView } from '@/utils/index'
import { useGenerateRefAndState } from "@/utils/useHooks";
import { newPath, EmailLink, SubLink } from '@/utils/index'
import { getHomeData, getSubData } from '@/api/index'

import M1 from '@/static/images/sub/m1.png'
import M2 from '@/static/images/sub/m2.png'
import Banner from '@/static/images/sub/banner.gif'
import Center from '@/static/images/sub/center.gif'
import P1 from '@/static/images/sub/p1.png'
import P2 from '@/static/images/sub/p2.png'
import P3 from '@/static/images/sub/p3.png'
import P4 from '@/static/images/sub/p4.png'
import P5 from '@/static/images/sub/p5.png'
import P6 from '@/static/images/sub/p6.png'
import Pr1 from '@/static/images/sub/pr1.png'
import Pr2 from '@/static/images/sub/pr2.png'
import Pr3 from '@/static/images/sub/pr3.png'
import { Root } from './css'
import { Progress } from '../products/css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  const programsRef = useRef(null)
  useActionWhenScrollToView(programsRef, () => {
    const target = document.querySelector('#__programs')
    target && target.closest('.programs') && target.closest('.programs').classList.add('show')
  }, true, () => {
    // const target = document.querySelector('#__programs')
    // target && target.classList.remove('show')
  })

  const functions1Ref = useRef(null)
  const functions2Ref = useRef(null)
  useActionWhenScrollToView(functions1Ref, () => {
    const target = document.querySelector('#__functions')
    target && target.classList.add('show1')
    setTimeout(() => {
      target && target.classList.add('showEnd1')
    }, 2000);
  }, true, () => {
    // const target = document.querySelector('#__functions')
    // target && target.classList.remove('showEnd1')
    // target && target.classList.remove('show1')
  })
  useActionWhenScrollToView(functions2Ref, () => {
    const target = document.querySelector('#__functions')
    target && target.classList.add('show2')
    setTimeout(() => {
      target && target.classList.add('showEnd2')
    }, 2000);
  }, true, () => {
    // const target = document.querySelector('#__functions')
    // target && target.classList.remove('showEnd2')
    // target && target.classList.remove('show2')
  })

  const progressFn = (action = 'add') => (target) => {
    const parent = target.parentElement
    parent && parent.classList[action]('show')
    parent && action === 'add' && parent.classList.add('show-once')
  }
  const progress1Ref = useRef(null)
  const progress2Ref = useRef(null)
  const progress3Ref = useRef(null)
  useActionWhenScrollToView(progress1Ref, progressFn(), false, progressFn('remove'))
  useActionWhenScrollToView(progress2Ref, progressFn(), false, progressFn('remove'))
  useActionWhenScrollToView(progress3Ref, progressFn(), false, progressFn('remove'))

  // subProjectCount,    messages, projects, subscribers
  const [datas, setDatas, datasRef] = useGenerateRefAndState({})
  useEffect(() => {
    const fn = async (times, types = ['home', 'sub']) => {
      if (times > 3) {
        return
      }
      let data1 = null
      let data2 = null
      let _types = []
      if (types.includes('home')) {
        // { subProjectCount }
        data1 = await getHomeData();
        (!data1 || !('subProjectCount' in data1)) && _types.push('home')
      }
      if (types.includes('sub')) {
        // { messages, projects, subscribers }
        data2 = await getSubData();
        (!data2 || !('messages' in data2)) && _types.push('sub')
      }
      const data = {
        ...datasRef.current,
        ...(data1 || {}),
        ...(data2 || {}),
      }
      setDatas(data)
      if (_types.length) {
        await new Promise((resolve) => setTimeout(resolve, 800));
        fn(times + 1, _types)
      }
    }
    fn(0)
  }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[1].name} />
      <div className="content">
        <div className="center dapp dapp1">
          <div className="info">
            <h1>Subscription & Notification</h1>
            <div className="desc" style={{ fontSize: isMobile ? '' : '18px' }}>Subscription & Notification is a revolutionary platform for developers and influencers that enables them to send personalized and targeted messages, marketing notifications to subscribers with wallet addresses and DIDs.</div>
            <div className="actions">
              <a className="filled-red" href={SubLink} target="_blank">Subscription & Notification</a>
              <a className="outlined-red" href="https://mail.dmail.ai/hubs/subcenter" target="_blank">Ecosystem</a>
            </div>
          </div>
          <div className="img">
            <img src={isMobile ? M1 : Banner} width={613} />
          </div>
        </div>
        <div className="center">
          <ul className="sub-data">
            <li>
              <div className="text">
                <p>Onboarded Projects</p>
                <strong>{datas.projects}</strong>
              </div>
              <div className="icon"><SvgsSubscription type="board" /></div>
            </li>
            <li>
              <div className="text">
                <p>Subscriber Count</p>
                <strong>{datas.subscribers}</strong>
              </div>
              <div className="icon"><SvgsSubscription type="user" /></div>
            </li>
            <li>
              <div className="text">
                <p>Messages Sent</p>
                <strong>{datas.messages}</strong>
              </div>
              <div className="icon"><SvgsSubscription type="email" /></div>
            </li>
          </ul>
        </div>
        <div className="functions" id="__functions">
          <ul className="center">
            <div className="blank1" ref={functions1Ref}></div>
            <div className="blank2" ref={functions2Ref}></div>
            <li>
              <div className="img"><img src={P1} width={43} alt="" /></div>
              <div className="name">Targeted Messaging</div>
              <div className="desc"><p>Precise and tailored push messages can be differentiated based on groups or labels.</p></div>
            </li>
            <li>
              <div className="img"><img src={P2} width={50} alt="" /></div>
              <div className="name">User Profile</div>
              <div className="desc"><p>Analyzing users' wallet addresses using AI algorithms to segment user profiles and create labels.</p></div>
            </li>
            <li>
              <div className="img"><img src={P3} width={50} alt="" /></div>
              <div className="name">Points System</div>
              <div className="desc"><p>Integrate multiple mission platforms and validate NFT & OAT credentials with point rewards to form a unified loyalty program.</p></div>
            </li>
            <li>
              <div className="img"><img src={P4} width={51} alt="" /></div>
              <div className="name">Business Bio</div>
              <div className="desc"><p>Showcase your project's subscription, social media, updates and campaigns through unified link.</p></div>
            </li>
            <li>
              <div className="img"><img src={P5} width={50} alt="" /></div>
              <div className="name">Multi-Channel Notification</div>
              <div className="desc"><p>Notify subscribers on their channels of choice, including wallet address, email, telegram and discord.</p></div>
            </li>
            <li>
              <div className="img"><img src={P6} width={51} alt="" /></div>
              <div className="name">Marketing Growth</div>
              <div className="desc"><p>Access to Dmail's 4M+ user base and provide multiple effective and accurate user growth services.</p></div>
            </li>
          </ul>
        </div>
        <div className="dapp programs">
          <div className="left">
            <div className="info" id="__programs">
              <h1>Subscription Center</h1>
              <div className="desc">
                {/* <p><i /><span>Over <strong>3,500,000</strong> active users in the Dmail community are the driving force behind Subscription & Notification!</span></p> */}
                <p><span>More than <strong>{datas.subProjectCount || '--'} developers and partners</strong> from various sectors including DIDs, Wallets, GameFi, SocialFi, DeFi Protocols and Infrastructures joined the subscription center and are utilizing the SubHub messaging service.</span></p>
              </div>
              <div className="actions">
                <a className="filled-red" href="https://mail.dmail.ai/hubs/subcenter" target="_blank">Subscribe Now</a>
              </div>
              <div ref={programsRef}></div>
            </div>
          </div>
          <div className="img">
            <img src={isMobile ? M2 : Center} />
          </div>
        </div>
        <Progress  className={`sub-process ${isMobile ? 'sub-mobile' : ''}`}>
          <div className="center">
            <div className="flex">
              <div className="img"><img src={Pr1} alt="" width={540} /></div>
              <div className="line"></div>
              <div className="info" ref={progress1Ref}>
                <h3>Precision Push</h3>
                <p><i></i>User Profiling</p>
                <p><i></i>Intelligent Grouping</p>
                <p><i></i>Targeted Messages</p>
              </div>
            </div>
            <div className="flex flex-reverse">
              <div className="info" ref={progress2Ref}>
                <h3>Business Bio</h3>
                <p><i></i>Subscription</p>
                <p><i></i>Business Overview</p>
                <p><i></i>Events & Bulletins</p>
              </div>
              <div className="line"></div>
              <div className="img"><img src={Pr3} alt="" width={540} /></div>
            </div>
            <div className="flex">
              <div className="img"><img src={Pr2} alt="" width={540} /></div>
              <div className="line"></div>
              <div className="info" ref={progress3Ref}>
                <h3>Multi-Channel Notification</h3>
                <p><i></i>Dmail DApp</p>
                <p><i></i>Browser Pop-up</p>
                <p><i></i>Social Apps</p>
                <p><i></i>Email Forwarding</p>
              </div>
            </div>
          </div>
        </Progress>
      </div>
      <div className="bottom">
        <div className="center">
          <Subscribe />
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))